export default __webpack_public_path__ + "static/media/photo9.6401c51d.jpg";